import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "@/api";
import { sleep } from "@/shared/utils";
import { MutationConfig, MutationResult } from "@/shared/types/base";
import { ReactNode } from "react";
import { Rubro } from "@/shared/types/rubro";

export interface RubroEditRequest {
    nombre?: string,
    email?: string,
    numDocumento?: string,
    telefono?: string,
    direccion?: string,
}

export async function editRubro(id: string, request: RubroEditRequest): Promise<Rubro> {
    await sleep(1000);
    const response = await api.put("rubros/" + id, request);
    return response.data;
}

export function useEditRubroMutation(id: string, mutationConfig: MutationConfig<Rubro, RubroEditRequest> = {}) {
    const queryClient = useQueryClient();
    return useMutation({
        ...mutationConfig,
        mutationFn: async (request: RubroEditRequest) => await editRubro(id, request),
        onSuccess: (...args) => {
            mutationConfig.onSuccess && mutationConfig.onSuccess(...args);
            queryClient.invalidateQueries({ queryKey: ["rubros"] });
        },
    })
}

export interface EditRubroMutationProps{
    id: string, 
    mutationConfig?: MutationConfig<Rubro, RubroEditRequest>,
    children?:(mutationResult:MutationResult<Rubro, RubroEditRequest>)=>ReactNode
}

export function EditRubroMutation({
    id,
    children,
    mutationConfig
}:EditRubroMutationProps){
    const mutationResult = useEditRubroMutation(id, mutationConfig);
    return children&&children(mutationResult)
}